import ol from "openlayers";

const domainMap = "https://gis-quyhoach.greenglobal.vn/arcgis/services";
// google
export const Google_Layer_Ve_Tinh = new ol.layer.Tile({
  visible: false,
  preload: Infinity,
  source: new ol.source.TileImage({
    url: "https://mt0.google.com/vt/lyrs=y&hl=vi&x={x}&y={y}&z={z}&s=Ga",
    crossOrigin: "Anonymous",
  }),
});

export const Google_Layer_Ban_Do = new ol.layer.Tile({
  visible: false,
  source: new ol.source.OSM({
    url: "https://mt0.google.com/vt/lyrs=t,m&hl=vi&x={x}&y={y}&z={z}&s=",
    crossOrigin: "Anonymous",
    attributions: [
      new ol.Attribution({ html: "© Google" }),
      new ol.Attribution({
        html:
          '<a href="https://developers.google.com/maps/terms">Terms of Use.</a>',
      }),
    ],
  }),
});

//--------------------==========--------------------//

// quy hoach chi tiet
export const QHCT_Polygon = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "4",
      FORMAT: "image/png",
    },
  }),
});

export const QHCT_Line = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "8",
      FORMAT: "image/png",
    },
  }),
});

export const QHCT_RanhGioi = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "1",
      FORMAT: "image/png",
    },
  }),
});
//--------------------==========--------------------//

// quy hoach phan khu
export const QHPK_Polygon = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "2",
      FORMAT: "image/png",
    },
  }),
});

export const QHPK_Line = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "6",
      FORMAT: "image/png",
    },
  }),
});

export const QHPK_RanhGioi = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});
//--------------------==========--------------------//

// quy hoach chung
export const QHC_Polygon = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "3",
      FORMAT: "image/png",
    },
  }),
});

export const QHC_Line = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "7",
      FORMAT: "image/png",
    },
  }),
});

export const QHC_RanhGioi = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/RGQHChung/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});
//--------------------==========--------------------//

// kien truc
export const KienTruc = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "5",
      FORMAT: "image/png",
    },
  }),
});
//--------------------==========--------------------//

// dia chinh
export const RanhGioiDiaChinh = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/DiaChinh/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});

export const ThongTinDiaChinh = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/TTDiaChinh/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    wrapX: false,
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});

export const RanhGioiHanhChinh = new ol.layer.Tile({
  visible: false,
  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/RanhGioiHanhChinh/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    wrapX: false,
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});

export const BienSoNha = new ol.layer.Tile({
  visible: false,

  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/SoNha/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});

export const BanDo64 = new ol.layer.Tile({
  visible: false,

  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/BD64/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "0,1,2,3",
      FORMAT: "image/png",
    },
  }),
});

export const QHC_HienTrang = new ol.layer.Tile({
  visible: false,

  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/MatBangPolygon_HienTrang/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});

export const QHC_Test = new ol.layer.Tile({
  visible: false,

  source: new ol.source.TileWMS({
    url: domainMap + "/SoXayDung/MatBangQHChung_Test/MapServer/WMSServer",
    crossOrigin: "Anonymous",
    params: {
      LAYERS: "0",
      FORMAT: "image/png",
    },
  }),
});

export const iconGeometry = new ol.geom.Point([
  12045324.924720876,
  1806357.9277613866,
]);

export const iconStyle = new ol.style.Style({
  image: new ol.style.Icon({
    anchor: [0.5, 1],
    anchorXUnits: "fraction",
    anchorYUnits: "fraction",
    opacity: 0.75,
    src: "Map-Marker-Bubble-Azure-icon.png",
    crossOrigin: "Anonymous",
  }),
});
